import React from "react";

import BookGrid from "../BookGrid";

export default function AdditionalBook (props) {
    const {
        additional_resource_title = null,
        additional_resource_book = [],
        additional_resource_autoplay = false,
        additional_resource_autoplay_delay = 5000,
        related_article_view_all_button_label = "",
        related_article_view_all_button_link = "",
    } = props;

    return (
        <>
        {
            additional_resource_book !== null && additional_resource_book.length > 0 && (
                <BookGrid
                    title={additional_resource_title !== null && additional_resource_title !== "" ? additional_resource_title : "You may also be interested in"}
                    autoplay = {additional_resource_autoplay}
                    delay = {additional_resource_autoplay_delay}
                    books = {additional_resource_book}
                    view_all_button_label = {related_article_view_all_button_label === undefined ? related_article_view_all_button_label : ""}
                    view_all_button_link = {related_article_view_all_button_link === undefined ? related_article_view_all_button_link : ""}
                />
            )
        }
        </>
    )
}